import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const TimeItem = styled.div`
    display: flex;

    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    width: 89px;
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        width: 90px;
    }

    white-space: nowrap;
    padding: 12px 8px;
`;
